//import { API_BASE_URL } from "../constants";
import { apiendpoints } from "../constants/api-endpoints";
import { APICLIENT, JWT, USERINFO } from "../shared";

export const Login = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader());
    // const response = await axioClient.post("/Account/Login", data);
    const response = await axioClient.post(apiendpoints.LOGIN_OTP_API, data);
    const res = APICLIENT.handleResponse(response);
    if (res?.isSuccess) {
      JWT.setJwt(res?.accessToken);
         JWT.setRefreshJwt(res?.refreshToken?.tokenString);
      USERINFO.setUserId(res?.data.userID);
    }
    return res;
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const LoginAdmin = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader());
    const response = await axioClient.post("/Account/Login", data);
    const res = APICLIENT.handleResponse(response);
    if (res?.isSuccess) {
      JWT.setJwt(res?.accessToken);
      JWT.setRefreshJwt(res?.refreshToken?.tokenString);
      USERINFO.setUserId(res?.data.userID);
    }
    return res;
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const Login2FA = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader());
    const response = await axioClient.post(apiendpoints.LOGIN_2FA_API, data);
    const res = APICLIENT.handleResponse(response);
    return res;
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const SignUp = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader());
    const response = await axioClient.post(apiendpoints.SIGNUP_API, data);
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const SignOut = async () => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader());
    const response = await axioClient.post(apiendpoints.SIGNOUT_API);
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const ForgotPassword = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader());
    const response = await axioClient.post(
      apiendpoints.FORGOTPASSWORD_API,
      data
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

// export const changeAdminPassword = async (data) => {
//   try {
//     const axioClient = APICLIENT.axioClient(APICLIENT.getHeader());
//     const response = await axioClient.post(
//       `${API_BASE_URL}${apiendpoints.USER_PROFILE_CHANGE_PASSWORD}${data.token}`,
//       data
//     );
//     return APICLIENT.handleResponse(response);
//   } catch (err) {
//     return APICLIENT.handleError(err);
//   }
// };

export const setLoginUser = (user) => {
  localStorage.setItem("user", JSON.stringify(user));
};

export const getLoginUser = () => {
  const user = localStorage.getItem("user");
  if (user !== null && user !== undefined) {
    return JSON.parse(user);
  } else {
    return null;
  }
};

export const removeLoginUser = () => {
  localStorage.removeItem("user");
};

export const changePasswordAdmin = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.post(
      apiendpoints.CHANGE_PASSWORD_ADMIN,
      data
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const changeUserPassword = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.post(
      apiendpoints.USER_PROFILE_CHANGE_PASSWORD,
      data
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const getApproveRejectUsers = async () => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(apiendpoints.GET_ADMIN_USER_APPROVAL);
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const approveRejectUser = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.post(
      apiendpoints.UPDATE_ADMIN_USER_APPROVAL,
      data
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};


export const emailChangeRequest = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
     const response = await axioClient.post(
      apiendpoints.EMAIL_CHANGE,
      data
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};


export const confirmEmail = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
     const response = await axioClient.post(
      apiendpoints.CONFIRM_EMAIL,
      data
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const confirmEmailChange = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
     const response = await axioClient.post(
      apiendpoints.CONFIRM_EMAIL_CHANGE,
      data
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};
